module.exports = __webpack_public_path__ + "img/gsa.5fe04d6b.png";